import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";
import EventGiftSummary from "./EventGiftSummary";

const channel = commonUtil.getChannel();

class EventGiftModalOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Regalo del evento",
    };
  }

  componentDidMount() {
    this.setState({ title: "Regalo del evento" });
    document.body.classList.add('body-no-scroll');
  }

  render() {
    const { title } = this.state;
    const { userEventDetails } = this.props;

    return (
      <div id="event-gift-modal-overlay" className="evnt_modal_overlay">
        <div className="modal-content-event">
          <div className="evnt-modal-header">
            <h4 className="modal-title">{title}</h4>
            <button
              className="close-button"
              onClick={this.props.hideModalOverlay}
              aria-label="Cerrar modal"
            >
              <img
                src={commonUtil.getAssetURL() + "/images/close.svg"}
                alt=""
                className="icon_vozcliente"
              />
            </button>
          </div>
          <div className="evnt_modal_body" onClick={(e) => e.stopPropagation()}>
            <EventGiftSummary 
              isWap={channel == "wap"} 
              getEventThresholdGiftDetails={this.props.getEventThresholdGiftDetails}
              userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
              getPurchaseInfoDetails={this.props.getPurchaseInfoDetails}
              purchaseInfoDetails={this.props.purchaseInfoDetails}
              eventType={userEventDetails?.eventDetailsInfo?.eventType || ""}
              eventId={userEventDetails?.eventDetailsInfo?.eventId || ""}
              userEventDetails={this.props.userEventDetails}
              deliveryAddress={this.props.deliveryAddress}
              hideModalOverlay={this.props.hideModalOverlay}
              selectedTheme ={this.props.selectedTheme || {}}
              lables={this.props.lables}
              eventInfo={this.props.eventInfo}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default EventGiftModalOverlay;
